<template>
  <CarrierMessenger
    v-if="renderCarrierMessenger"
    :carrier-store="carrierStore"
    :user-store="userStore"
    :current-user="currentUser"
    :carrier-messaging-sse-enabled="carrierMessagingSseEnabled"
  />
</template>

<script lang="ts" setup>
import { useFlag } from '@unleash/proxy-client-vue';
import { computed, onMounted, toRefs } from 'vue';

import { useMessagingSenderAccounts } from '@rygen/rygen-ui/composables/carrierMessaging';
import { CurrentUser } from '@rygen/rygen-ui/model';

import { useCarrierStore } from '@/stores/Carrier';
import { useUserStore } from '@/stores/User';

import CarrierMessenger from '@rygen/rygen-ui/components/carrier/messaging/CarrierMessenger.vue';

const props = defineProps({
  currentUser: {
    type: CurrentUser,
    default: () => undefined,
  },
});
const { currentUser } = toRefs(props);

const carrierStore = useCarrierStore();
const { hasSenderAccountsForMessaging, refreshMessagingAccounts } =
  useMessagingSenderAccounts();
const userStore = useUserStore();
const carrierMessagingSseEnabled = useFlag('carrier-messaging-sse-feat-flag');

const renderCarrierMessenger = computed(
  () => currentUser?.value && hasSenderAccountsForMessaging.value,
);

onMounted(() => refreshMessagingAccounts());
</script>
